import { http } from '@pendo/http';

export function createVocItemMedia (vocItemId, mediaType, { altText } = {}) {
    const body = altText ? { altText } : { altText: '' };

    return http
        .post(`/api/s/_SID_/vocItem/${vocItemId}/media/${mediaType}`, body)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function createVocMedia (mediaType, fileName, fileType) {
    return http
        .post(
            `/api/s/_SID_/voc/mediaFile/${mediaType}`,
            { fileType, fileName },
            { headers: { 'Content-Type': 'application/json' } },
        )
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function createAttachmentMedia (vocItemId, fileName, fileType) {
    return http
        .post(
            `/api/s/_SID_/vocItem/${vocItemId}/media/attachment`,
            { fileType, fileName },
            { headers: { 'Content-Type': 'application/json' } },
        )
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function addAttachmentToVocItem (vocItemId, attachmentId) {
    return http
        .post(`/api/s/_SID_/vocItem/${vocItemId}/attachment/${attachmentId}`, {
            headers: { 'Content-Type': 'application/json' },
        })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function fetchAttachmentUrl (vocItemId, attachmentId) {
    return http
        .get(`/api/s/_SID_/vocItem/${vocItemId}/media/attachment/${attachmentId}`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function fetchBannerImageUrl (vocItemId, bannerImageId) {
    return http
        .get(`/api/s/_SID_/vocItem/${vocItemId}/media/bannerImage/${bannerImageId}`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function updateBannerImageAltText (vocItemId, bannerImageId, altText) {
    return http
        .put(`/api/s/_SID_/vocItem/${vocItemId}/media/${bannerImageId}`, { altText })
        .then((res) => res?.data)
        .catch((err) => {
            throw err;
        });
}

export async function copyVocItemMedia ({ guideId, vocItemId, mediaFileType, mediaFileId }) {
    return http.post(`/api/s/_SID_/vocItem/${vocItemId}/media/${mediaFileType}/${mediaFileId}/publish`, {
        guideId,
    });
}

export function deleteAttachment (vocItemId, attachmentId) {
    return http.delete(`/api/s/_SID_/vocItem/${vocItemId}/attachment/${attachmentId}`).catch((err) => {
        throw err;
    });
}

export function getDefaultBannerImage () {
    return http
        .get('/api/s/_SID_/vocItem/emailUpdateDefaultCoverImage')
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function updateDefaultBannerImage ({ vocItemId, mediaFileId }) {
    return http
        .post(`/api/s/_SID_/vocItem/${vocItemId}/vocItemUpdate/defaultCoverImage`, {
            mediaFileId,
        })
        .catch((err) => {
            throw err;
        });
}
